import React from 'react';
import { Spinner } from 'tuui';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { FormInitBase } from 'modules/taboola-common-frontend-modules/forms';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { ModalFormLayout } from 'modules/taboola-common-frontend-modules/modals/components/ModalFormLayout/ModalFormLayout';
import { useDuplicateLandingPageState } from '../../hooks/useDuplicateLandingPageState';
import { Title } from '../FormFields/Title/Title';
import styles from './duplicateLandingPageModal.module.scss';

export const DuplicateLandingPageModal = ({ onClose, initialData }) => {
    const { value: title } = useFormFieldValue({ field: 'title' });
    const { handleSubmit, handleCancel, isSubmitting } = useDuplicateLandingPageState({ onClose, initialData });
    const trimmedTitle = title?.trim();

    return (
        <FormInitBase>
            <ModalFormLayout
                className={styles['duplicate-landing-page-modal']}
                onCancel={handleCancel}
                onSubmit={handleSubmit}
                submitButtonText={
                    isSubmitting ? (
                        <div className={styles['submit-progress']}>
                            <Spinner size={14} />
                        </div>
                    ) : (
                        <FormattedMessage id="landing.pages.duplicate.modal.submit" defaultMessage="Duplicate" />
                    )
                }
                cancelButtonText={<FormattedMessage id="app.actionButtons.cancel" defaultMessage="Cancel" />}
                disableSubmit={!trimmedTitle || isSubmitting}
                disableCancel={isSubmitting}
            >
                <div className={styles['modal-content']}>
                    <Title className={styles['input-element']} inputWrapperClass={styles['input-wrapper']} />
                </div>
            </ModalFormLayout>
        </FormInitBase>
    );
};
